"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MechanicsList;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var MechanicsTable_1 = __importDefault(require("../Mechanics/MechanicsTable"));
var groupMechanicsByType_1 = require("@utils/mechanics/groupMechanicsByType");
var useHandleEmptyList_1 = require("@hooks/useHandleEmptyList");
// Компонент списка механик
function MechanicsList() {
    var mechanics = (0, react_redux_1.useSelector)(function (state) { return state.mechanicsSlice; }).mechanics;
    var types = (0, react_redux_1.useSelector)(function (state) { return state.mechanicsTypeSlice; }).types;
    var mechanicsHandler = (0, useHandleEmptyList_1.useHandleEmptyList)({ data: mechanics });
    if (mechanicsHandler)
        return mechanicsHandler;
    // Получаем список механик из Redux состояния
    var groupedMechanics = (0, groupMechanicsByType_1.groupdMechanics)(types, mechanics);
    // Сгруппировать механики, у которых нет типа (например, typeId === "unknown" или не определен)
    var mechanicsWithoutType = (0, groupMechanicsByType_1.unsortedMechanics)(types, mechanics);
    // Добавляем механики без типа в отдельную группу
    if (mechanicsWithoutType.length > 0) {
        groupedMechanics.push({
            type: { id: "unknown", type: "unspecified" },
            mechanics: mechanicsWithoutType,
        });
    }
    return ((0, jsx_runtime_1.jsx)("div", { style: { overflowX: "hidden", width: "100%" }, children: (0, jsx_runtime_1.jsx)("ul", { style: { listStyle: "none", margin: "0", padding: "0" }, children: groupedMechanics.length > 0
                ? groupedMechanics.map(function (gr) { return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)(MechanicsTable_1.default, { group: gr }) }, gr.type.id)); })
                : null }) }));
}
